import { HiOutlineSparkles } from '@/components/react-icons/main';
import Spinner from '@/components/Spinner.jsx';
import IconV2 from '@/components/v2/IconV2';
import React from 'react';

const AiSuggestionsTrigger = React.forwardRef(({ title, size = 'md', suggestionsLength = 0, hasSuggestions = false, outlined = false, loading = false, showCount = false, className, ...props }, ref) => {
  return (
    <div className={`comp-ai-suggestions ${hasSuggestions ? 'has-suggestions' : ''} size-${size} ${outlined ? 'outlined' : ''} ${loading ? 'loading' : ''} ${className}`} data-title={title} role="button" ref={ref} {...props}>
      <IconV2 icon={HiOutlineSparkles} />
      {showCount && (
        <div className="comp-ai-suggestion-count">
          {loading && <Spinner />}
          {!loading && suggestionsLength > 0 && <>{suggestionsLength}</>}
        </div>
      )}
    </div>
  );
});

AiSuggestionsTrigger.displayName = 'AiSuggestionsTrigger';
export default AiSuggestionsTrigger;
